import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-vertical-align-top",
  templateUrl: "./med-icon-vertical-align-top.component.html",
})
export class MedIconVerticalAlignTopComponent  extends SvgMixinComponent {}
